<template>
        <b-navbar toggleable="md" :sticky="true" class="top-bar">
            <b-navbar-brand :to="{ name: ManagerRouteNames.dashboard }">
                <img :src="$root.serverBasePath + '/strata.png'" alt="Strata Connex" height="40px"/>
            </b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto center-bar">
                    <b-nav-item :to="{ name: ManagerRouteNames.dashboard }" :active="isActive(ManagerRouteNames.dashboard)">Dashboard</b-nav-item>
                    <b-nav-item :to="{ name: ManagerRouteNames.quote }" :active="isActive(ManagerRouteNames.quote)" >Quotes</b-nav-item>
                    <b-nav-item :to="{ name: ManagerRouteNames.workOrder}" :active="isActive(ManagerRouteNames.workOrder)"  >Work Orders</b-nav-item>
                    <b-nav-item :to="{ name: ManagerRouteNames.strataPlan}" :active="isActive(ManagerRouteNames.strataPlan)" >Strata Plans</b-nav-item>
                    <b-nav-item :to="{ name: ManagerRouteNames.contactContractors }" :active="isActive(ManagerRouteNames.contactContractors)" >Contacts</b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav class="ml-auto bar-right">
                    <!--                    <b-nav-item href="#"><i class="fas fa-question-circle fa-lg"></i></b-nav-item>-->

                    <b-nav-item-dropdown right>
                        <template #button-content>
                            <img :src="$root.serverBasePath + '/images/profile-placeholder.png'" alt="user image"
                                 class="nav-img">
                            <span class="nav-img-color"></span>
                        </template>

                        <div class="user-info py-3">
                            <b-dropdown-item :to="{ name: 'edit-manager-profile' }" class="mb-2">
                                {{$store.state.authenticatedUserData.user.full_name}}
                            </b-dropdown-item>
                            <b-dropdown-item>
                                {{$store.state.authenticatedUserData.business ? $store.state.authenticatedUserData.business.company_name : '' }}
                            </b-dropdown-item>
                        </div>
                        <hr>
                        <div class="user-nav">
                            <b-dropdown-item :to="{ name: 'edit-manager-profile' }">
                                <i class="fa fa-user fa-lg mr-3" aria-hidden="true"></i>
                                Profile
                            </b-dropdown-item>
                            <b-dropdown-item :to="{ name: 'manager-add-members' }">
                                <i class="fa fa-building fa-lg mr-3" aria-hidden="true"></i>
                                Manage Org
                            </b-dropdown-item>
                            <b-dropdown-item @click="logout"><i class="fas fa-sign-out-alt fa-lg mr-3"></i>Logout
                            </b-dropdown-item>
                        </div>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
</template>

<script>
import {ManagerMainRoutes, ManagerRouteNames} from "../../../routeNames";

export default {
    computed: {
        ManagerRouteNames() {
            return ManagerRouteNames
        },
        currentRoute() {
            return this.$route.name;
        }
    },
    methods: {
        logout() {
            axios.post("logout").then(() => {
                this.$store.commit("setUserLoggedOut");
                this.$router.push({name: "login"});
            });
        },
        isActive(routeName) {
            return ManagerMainRoutes[routeName].includes(this.currentRoute);
        }
    }
};

</script>


